import { Copy } from "lucide-react";
import { useToast } from "./Toast.jsx";

async function copyText(value) {
  const text = String(value || "").trim();
  if (!text) return;
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Some browsers expose Clipboard but block it outside a secure context.
    }
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  textarea.remove();
}

export function CopyableText({
  as = "button",
  children,
  className = "",
  copiedMessage,
  errorMessage,
  iconOnly = false,
  label = "valor",
  value,
}) {
  const { showToast } = useToast();
  const Component = as;

  const handleCopy = async (event) => {
    event.stopPropagation();
    try {
      await copyText(value);
      showToast({
        message:
          copiedMessage ||
          `${label.charAt(0).toUpperCase()}${label.slice(1)} copiado`,
        tone: "success",
      });
    } catch {
      showToast({
        message: errorMessage || `No pudimos copiar ${label}`,
        tone: "danger",
      });
    }
  };

  const handleKeyDown = (event) => {
    event.stopPropagation();
    if (as !== "button" && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      handleCopy(event);
    }
  };

  return (
    <Component
      {...(as === "button"
        ? { type: "button" }
        : { role: "button", tabIndex: 0 })}
      className={`suite-copyable-text ${iconOnly ? "is-icon-only" : ""} ${className}`.trim()}
      aria-label={`Copiar ${label}`}
      title={`Copiar ${label}`}
      onClick={handleCopy}
      onKeyDown={handleKeyDown}
    >
      {!iconOnly && <span>{children ?? value}</span>}
      <span className="suite-copyable-text-icon" aria-hidden="true">
        <Copy size={12} />
      </span>
    </Component>
  );
}
